import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import * as React from 'react';
import { TextField } from '../textfield';
import { DESKTOP_MEDIA_QUERY } from '../theme';
import { withVersion } from '../utils';
import { fromMomentToLocalDate, toMoment, useDateSlotProps } from './utils';
export * from './provider';
export const DatePicker = withVersion((props) => {
    const { value, minDate, maxDate, skeleton, size = 'small', width = '100%', onChange, slotProps: orgSlotProps, required, ...muiProps } = props;
    const slotProps = useDateSlotProps({
        ...props,
        slotProps: {
            ...orgSlotProps,
            actionBar: { actions: ['today'] },
            layout: {
                sx: {
                    '.MuiPickersLayout-actionBar': { gridColumn: 'left' }
                }
            },
            textField: {
                required
            }
        },
        size,
        width
    });
    if (skeleton) {
        return _jsx(TextField, { width: width, skeleton: true });
    }
    return (_jsx(MuiDatePicker, { ...muiProps, ...slotProps, desktopModeMediaQuery: DESKTOP_MEDIA_QUERY, sx: { width, ...muiProps.sx }, value: toMoment.nullable(value), minDate: toMoment(minDate), maxDate: toMoment(maxDate), onChange: (date) => {
            onChange?.(fromMomentToLocalDate(date));
        } }));
}, '1.0.0');
